import { fa } from '../firebase/fb';
import { ApiError } from './ApiError';

const baseUrl = window.location.origin.includes('localhost')
  ? 'https://home.student-dev.monash'
  : window.location.origin;

const altBE = JSON.parse(sessionStorage.getItem('alt-backend'));
const apiPath = altBE ? `/api-${altBE}` : '/api';

const callApi = async (
  relativeUrl,
  method,
  bodyJson,
  fullPath = null,
  htmlResponse = false,
) => {
  const idToken = await fa.currentUser?.getIdTokenResult();
  const init = {
    headers: {
      Authorization: `Bearer ${idToken?.token}`,
    },
  };
  if (method) {
    init.method = method;
  }
  if (bodyJson) {
    init.body = JSON.stringify(bodyJson);
    init.headers['Content-Type'] = 'application/json';
  }

  const response = await fetch(
    fullPath || baseUrl + apiPath + relativeUrl,
    init,
  );

  if (!response.ok) {
    const errorText = await response.text();
    console.error('Response body', errorText);
    const error = new ApiError(`${response.status}: ${relativeUrl}`, errorText);
    error.status = response.status;
    throw error;
  }
  if (htmlResponse) {
    return await response.text();
  } else {
    return await response.json();
  }
};

export default callApi;
